"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* 
  The `VisuallyHidden` component allows us to signal intent to screen reader users,
  without breaking visual flow for sighted users.

  An example usage of this would be to add this component to a link that only uses an icon.

  <-- The following is not valid gf-styled code, serving as an example only -->
  <a href='#'>
    <VisuallyHidden>Settings</VisuallyHidden>
    <Icon id='cog'/>
  </a>

  For more information see: https://www.joshwcomeau.com/snippets/react-components/visually-hidden/
*/
var VisuallyHidden = (0, _styledComponents["default"])('span').withConfig({
  displayName: "visually-hidden__VisuallyHidden",
  componentId: "sc-1gcz9q0-0"
})(["&&&&{display:inline-block;position:absolute;overflow:hidden;clip:rect(0 0 0 0);height:1;width:1;margin:-1;padding:0;border:0;}"]);
var _default = VisuallyHidden;
exports["default"] = _default;